import {useTheme, css} from "@emotion/react";
import PropTypes from "prop-types";
import { em } from "@util/convertUnits";

const SingleListWidget = ({content}) => {


    const theme = useTheme();

    const listItemCss = css(`
        align-items: center;
        justify-content: left;
        display: flex;
        max-width: 95%;
        max-height: 90%;
        margin-bottom: 2em;
        max-height: 85%;
        text-align: left;
        padding:2em;

        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            min-width: 100%;
        }
    `)
    
    const listDomContainer = css(`
        flex-direction: column;
        display: flex;
        margin-top: 1em;

        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            justify-content: center;
            align-items:center;
            max-width: 40%
            margin-bottom: 2em;
        }
        
    `);

    const listStyles = css(`
        background-color:#F9F9F9;
        height: auto;
        padding:2em;
    `);

    const {list} = content;
    
    const listDom = list.map((e, i) => {
        const css = [listItemCss];
        if(i % 2 === 0){
            css.push(listStyles);
        }
        return <li css={css} key={e} dangerouslySetInnerHTML={{__html: e}}></li>
    })

    return <ul css={listDomContainer} className={'px-3'}>
        {listDom}
    </ul>;
};

SingleListWidget.propTypes = {
    content: PropTypes.object,
};

export default SingleListWidget;
